module.exports = __webpack_public_path__ + "images/fa75cae1f31f9640f7ee159c8196334d.svg";